import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
/// Add bootstrap vue to the project////
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
// import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
/////////////////////////////////////////////

///// SWEET ALERT FOR ALERT
import 'sweetalert2/dist/sweetalert2.min.css';
import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2);
///////////////////////////////////////////////
import '@/services/httpRequests.js'
//////////// ADDED AXIOS
import axios from 'axios'
/////////////////////////////////

////////// COOKIES ///////
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
Vue.$cookies.config('7d')
//////////////////////////////////////////

import ToggleButton from 'vue-js-toggle-button'
 
Vue.use(ToggleButton)


////// vue modal
import VModal from 'vue-js-modal'
Vue.use(VModal)
// /////////////////////////////
// import feather from 'vue-icon'
// Vue.use(feather, 'v-icon')


////////////


/////////////// DATA TABLES ///////
// import {IconsPlugin } from 'bootstrap-vue'
// //import css files
// import 'bootstrap-vue/dist/bootstrap-vue.css'
// // Install BootstrapVue
// Vue.use(BootstrapVue)
// // Optionally install the BootstrapVue icon components plugin
// Vue.use(IconsPlugin)
// //import css files
// import { TablePlugin } from 'bootstrap-vue'
// Vue.use(TablePlugin)
///////////////////////////////////////////////


// import './assets/style.css';
// import './assets/bootstrap.min.css';



Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
